export const iconFontAwesomeArrowsArrowsDownToLine = (
	<i className="fa-solid fa-arrows-down-to-line"></i>
);
